import { render, staticRenderFns } from "./EsgPartnerEvaluationMatrix.vue?vue&type=template&id=8824758a&scoped=true"
import script from "./EsgPartnerEvaluationMatrix.vue?vue&type=script&lang=js"
export * from "./EsgPartnerEvaluationMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8824758a",
  null
  
)

export default component.exports